import { TradeAllocations, type TradeAllocationsTabProps } from '@src/containers/Blotters/TradeAllocations';
import { MixpanelEventSource, MixpanelSourceProvider, type TabsState } from '@talos/kyoko';
import type { BlotterTablePanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

type AllocationsPanelConfig = BlotterTablePanelConfig & {
  tabs: TabsState<TradeAllocationsTabProps> | undefined;
};

export function AllocationsPanel({ params, api }: LayoutPanelProps<AllocationsPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.AllocationsBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="allocations-panel"
      >
        <TradeAllocations />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
